import { RadioProps } from '@storeblocks/radio-atom';

import { FMSTexts } from '@/types/fms';

export enum CitizenshipHighlightedCountries {
  Norway = 'NOR',
  Sweden = 'SWE',
  Danish = 'DNK',
  Other = 'OTHER',
}

export const citizenshipHighlightedCountriesOptions = (
  texts: FMSTexts,
): RadioProps[] => [
  {
    id: CitizenshipHighlightedCountries.Norway,
    value: CitizenshipHighlightedCountries.Norway,
    label: texts.orders.signatureRight.citizenship.highlightedCountries.nor,
  },
  {
    id: CitizenshipHighlightedCountries.Sweden,
    value: CitizenshipHighlightedCountries.Sweden,
    label: texts.orders.signatureRight.citizenship.highlightedCountries.swe,
  },
  {
    id: CitizenshipHighlightedCountries.Danish,
    value: CitizenshipHighlightedCountries.Danish,
    label: texts.orders.signatureRight.citizenship.highlightedCountries.dnk,
  },
  {
    id: CitizenshipHighlightedCountries.Other,
    value: CitizenshipHighlightedCountries.Other,
    label: texts.orders.signatureRight.citizenship.highlightedCountries.other,
  },
];
